
export const DELETE_CAREER_USER = "DELETE_CAREER_USER";
export const SET_CAREER_USER = "SET_CAREER_USER";
export const CHANGE_CAREER_STATUS = "CHANGE_CAREER_STATUS";
export const CHANGE_CAREER_MEMBERSHIP = "CHANGE_CAREER_MEMBERSHIP";
export const ADD_CAREER_USER = "ADD_CAREER_USER";
export const CAREER_COURSE_UNENROLL = "CAREER_COURSE_UNENROLL";
export const EDIT_CAREER_USER = "EDIT_CAREER_USER";